import { render, staticRenderFns } from "./AddProClassify.vue?vue&type=template&id=2214696b&scoped=true"
import script from "./AddProClassify.vue?vue&type=script&lang=js"
export * from "./AddProClassify.vue?vue&type=script&lang=js"
import style0 from "./AddProClassify.vue?vue&type=style&index=0&id=2214696b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2214696b",
  null
  
)

export default component.exports